<template>
  <b-modal
    v-model="showModal"
    :title="title"
    modal-class="modal-primary"
    hide-footer
    @hidden="$emit('hidden')"
    scrollable
    no-close-on-backdrop
    size="xmd"
  >
    <b-row class="mb-1">
      <b-col cols="12" class="d-flex justify-content-end">
        <b-col cols="2">
          <v-select
            v-model="status"
            :options="statusOptions"
            :reduce="(item) => item.id"
            :clearable="false"
          />
        </b-col>
      </b-col>
    </b-row>

    <b-row class="modal-reprogramar-vacaciones">
      <b-col cols="12">
        <b-table
          ref="vacaciones_programadas_table"
          sticky-header="60vh"
          hover
          :items="items"
          :fields="filteredFields"
          show-empty
          empty-text="No hay vacaciones disponibles para reprogramar"
          responsive
          primary-key="id"
        >
          <template #head(selected)>
            <b-form-checkbox v-model="selectAll" @change="toggleSelectAll" />
          </template>

          <template #cell(selected)="data">
            <b-form-checkbox
              v-if="data.item.comprado && !data.item.pagado && data.item.costo"
              v-model="data.item.selected"
              @change="handleCheckboxChange(data.item)"
            ></b-form-checkbox>
          </template>
          <template #cell(fecha)="data">
            <span>{{ data.value | myGlobal }}</span>
          </template>
          <template #cell(created_at)="data">
            <span>{{ data.value | myGlobalWithHour }}</span>
          </template>
          <template #cell(fecha_pago)="data">
            <span>{{ formatFechaPago(data.value) }}</span>
          </template>
          <template #cell(costo)="data">
            <div
              v-if="data.item.comprado && data.value"
              class="d-flex justify-content-center align-items-center"
            >
              <tabler-icon
                v-if="data.item.comprado == 1"
                icon="MoneybagIcon"
                :class="data.item.pagado ? 'text-success' : 'text-danger'"
                size="20"
                class="mr-1"
              />

              <span
                class="text-center"
                :class="data.item.pagado ? 'text-success' : 'text-danger'"
              >
                S/.{{ data.value | currencyZero }}
              </span>
            </div>
            <span v-else class="text-center">-</span>
          </template>
          <!-- <template #cell(actions)="data">
            <b-button
              v-if="data.item.comprado && !data.item.pagado && data.item.costo"
              size="sm"
              class="mr-1"
              variant="transparent"
              @click="pagar(data.item.id)"
            >
              <feather-icon icon="CheckIcon" class="text-success" size="16" />
            </b-button>
          </template> -->
        </b-table>
      </b-col>
    </b-row>

    <b-row v-if="status === 0" class="mt-2">
      <b-col cols="12" class="text-right">
        <b-button
          variant="outline-success"
          @click="pagar()"
          :disabled="selectedItems.length === 0"
        >
          Generar caja
        </b-button>
      </b-col>
    </b-row>
  </b-modal>
</template>

<script>
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import VacacionesService from "@/views/rrhh/views/payroll/components/vacaciones/service/vacaciones.service.js";
import { vacaciones_por_pagar_fields } from "@/views/rrhh/views/payroll/components/vacaciones/data/vacaciones.programadas.fields.js";
export default {
  props: {
    idPersonal: {
      type: Number,
      require: true,
    },
  },
  components: {
    ToastificationContent,
  },
  data() {
    return {
      selectAll: false,
      vacaciones_por_pagar_fields,
      showModal: true,
      items: [],
      empleado: {
        empleado: "",
      },
      selectedItems: [],
      status: 0,
      statusOptions: [
        { id: 0, label: "PENDIENTE" },
        { id: 1, label: "PAGADO" },
      ],
    };
  },
  computed: {
    title() {
      return `PAGAR VACACIONES: ${this.empleado.empleado}`;
    },
    periodoActual() {
      return this.selectedItems.length > 0
        ? this.selectedItems[0].anio_periodo
        : null;
    },
    filteredFields() {
      return this.vacaciones_por_pagar_fields
        .map((field) => {
          // Clona el objeto para que Vue detecte cambio
          return {
            ...field,
            visible:
              field.key === "selected" ? this.status !== 1 : field.visible,
          };
        })
        .filter((field) => field.visible !== false);
    },
  },
  mounted() {
    this.index();
  },
  watch: {
    status(newValue) {
      // Resetear selección y estado de selectAll al cambiar el estado
      this.selectedItems = [];
      this.selectAll = false;
      // Volver a cargar los datos
      this.index();
    },
  },
  methods: {
    toggleSelectAll() {
      const itemsValidos = this.items.filter(
        (i) => i.comprado && !i.pagado && i.costo
      );

      if (this.selectAll) {
        // Seleccionar todos los válidos
        this.selectedItems = [...itemsValidos];
        this.items.forEach((item) => {
          if (item.comprado && !item.pagado && item.costo) {
            item.selected = true;
          }
        });
      } else {
        // Deseleccionar todos
        this.selectedItems = this.selectedItems.filter(
          (i) => !(i.comprado && !i.pagado && i.costo)
        );
        this.items.forEach((item) => {
          if (item.comprado && !item.pagado && item.costo) {
            item.selected = false;
          }
        });
      }
    },
    handleCheckboxChange(item) {
      // Agregar o quitar el item de selectedItems
      const index = this.selectedItems.findIndex(
        (selectedItem) => selectedItem.id === item.id
      );

      if (index === -1) {
        this.selectedItems.push(item);
      } else {
        this.selectedItems.splice(index, 1);
      }

      // Filtrar solo los items válidos
      const itemsValidos = this.items.filter(
        (i) => i.comprado && !i.pagado && i.costo
      );

      // Si todos los válidos están seleccionados, marcar selectAll
      this.selectAll = itemsValidos.every((i) =>
        this.selectedItems.some((s) => s.id === i.id)
      );
    },
    formatFechaPago(fecha) {
      return fecha
        ? new Date(fecha).toLocaleString("es-PE", {
            dateStyle: "medium",
            timeStyle: "short",
          })
        : "";
    },
    async index() {
      try {
        this.addPreloader();
        const { data } = await VacacionesService.getVacacionesPorPagar({
          id_personal: this.idPersonal,
          estado: this.status,
        });

        // recorrer y poner propiedad seleccionado
        data.forEach((item) => {
          item.selected = false;
        });

        this.items = data;
      } catch (error) {
        console.error(error);
      } finally {
        this.removePreloader();
      }
    },
    generarTitulo() {
      const periodosUnicos = [
        ...new Set(this.selectedItems.map((item) => item.anio_periodo)),
      ].sort();

      if (periodosUnicos.length === 0) return "";

      if (periodosUnicos.length === 1) {
        return `CAJA PAGO VACACIONES PERIODO ${periodosUnicos[0]}`;
      }

      const primero = periodosUnicos[0];
      const ultimo = periodosUnicos[periodosUnicos.length - 1];
      return `CAJA PAGO VACACIONES PERIODO ${primero} - ${ultimo}`;
    },
    async pagar() {
      try {
        const { isConfirmed } = await this.showConfirmSwal();
        if (!isConfirmed) {
          return;
        }
        this.addPreloader();
        const { data } = await VacacionesService.pagarVacaciones({
          id_vacaciones: this.selectedItems.map((item) => item.id),
        });
        this.$toast({
          component: ToastificationContent,
          props: {
            title: "Pago realizado",
            icon: "CheckIcon",
            variant: "success",
            text: data.message,
          },
        });
        // Crear caja en soft titanic con la data de las vacaciones
        // console.log("selectedItems", this.selectedItems);
        const tituloCaja = this.generarTitulo();
        alert(tituloCaja);

        this.index();
      } catch (error) {
        console.error(error);
      } finally {
        this.removePreloader();
      }
    },
  },
};
</script>